<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-09-08 10:46:28
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-08-07 14:25:16
 * @FilePath: /wemeet-admin-new/src/views/exhibitionManage/components/userDetail.vue
 * @Description:
 * Copyright (c) 2023 by WeMeet, All Rights Reserved.
-->
<template>
  <el-drawer
    ref="drawerRef"
    v-model="dialogFormVisible"
    :before-close="handleClose"
    custom-class="demo-drawer userInfoDrawer"
    :direction="direction"
    :size="size"
    title="查看详情"
  >
    <div v-loading="detailLoading" class="containerForm">
      <el-descriptions border class="margin-top" title="">
        <el-descriptions-item label="用户名">
          {{ detail.name }}
          <el-tag v-if="detail.realStatus == 'PASS'" type="success">已实名</el-tag>
          <el-tag v-else-if="detail.realStatus == 'REFUSE'" type="danger">未实名</el-tag>
          <el-tag v-else-if="detail.realStatus == 'PENDING'" type="danger">实名待审核</el-tag>
          <el-tag v-else type="danger">未实名</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="手机号">
          {{ detail.phoneCountryCode + ' ' + detail.phone }}
        </el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag :color="getAuditLogColor(detail.auditStatus)" effect="dark" style="border: none">
            {{ statusList[detail.auditStatus] }}
          </el-tag>
        </el-descriptions-item>
      </el-descriptions>

      <el-descriptions border class="margin-top" title="用户基础信息">
        <el-descriptions-item label="公司/机构">
          {{ detail.organization ? detail.organization : '/' }}
        </el-descriptions-item>
        <el-descriptions-item label="职位">
          {{ detail.position ? detail.position : '/' }}
        </el-descriptions-item>
        <el-descriptions-item label="证件类型">
          {{ detail.idType ? identityCard[detail.idType] : '/' }}
        </el-descriptions-item>
        <el-descriptions-item label="证件号码">
          {{ detail.idNo ? detail.idNo : '/' }}
        </el-descriptions-item>
        <el-descriptions-item label="已报名的论坛">
          {{ detail.meetingNames ? detail.meetingNames.join('、') : '/' }}
        </el-descriptions-item>

        <el-descriptions-item v-if="detail.fileUrls?.length > 0" label="证件照片">
          <el-image
            fit="cover"
            :initial-index="4"
            :max-scale="7"
            :min-scale="0.2"
            :preview-src-list="[detail.fileUrls[0]]"
            :src="detail.fileUrls[0]"
            style="width: 100px; height: 100px"
            :zoom-rate="1.2"
          />
        </el-descriptions-item>
      </el-descriptions>

      <el-descriptions
        v-if="detail.attentFormDtoList?.length > 0"
        border
        class="margin-top"
        :column="1"
        title="自定义信息"
      >
        <template v-for="(item, index) in detail.attentFormDtoList" :key="index">
          <el-descriptions-item
            v-if="item.type != 'FILEUPLOAD' && item.type != 'AREA' && item.type != 'IMGUPLOAD'"
            :label="item.formTitle"
          >
            {{ item.formContent ? item.formContent : '/' }}
          </el-descriptions-item>

          <el-descriptions-item v-if="item.type == 'FILEUPLOAD'" :label="item.formTitle">
            <a :href="item.formContent.fileUrl" target="_blank">{{ item.formContent.fileName }}</a>
          </el-descriptions-item>
          <el-descriptions-item v-if="item.type == 'AREA'" :label="item.formTitle">
            {{ item.formContent.country }}
          </el-descriptions-item>

          <el-descriptions-item v-if="item.type == 'IMGUPLOAD'" :label="item.formTitle">
            <el-image
              v-if="item.formContent"
              fit="cover"
              :initial-index="4"
              :max-scale="7"
              :min-scale="0.2"
              :preview-src-list="[item.formContent]"
              :src="item.formContent"
              style="width: 100px; height: 100px"
              :zoom-rate="1.2"
            />
            <span v-else>/</span>
          </el-descriptions-item>
        </template>
      </el-descriptions>

      <el-descriptions border class="margin-top" :column="1" title="审核流水">
        <el-descriptions-item label="">
          <div v-loading="auditLogLoading">
            <el-timeline v-if="auditLog && auditLog.length" style="padding-left: 6px">
              <el-timeline-item
                v-for="(log, i) in auditLog"
                :key="i"
                :color="getAuditLogColor(log.status)"
                :timestamp="handleDate(log.createTime)"
              >
                <div>
                  <span style="font-weight: 600">{{ log.approver || '系统' }}</span>
                  <span style="margin: 0 6px; color: #909399">·</span>
                  <span :style="'color: ' + getAuditLogColor(log.status)">{{ statusList[log.status] }}</span>
                </div>
                <div v-if="log.reason" style="margin-top: 4px; color: #909399">原因：{{ log.reason }}</div>
              </el-timeline-item>
            </el-timeline>
            <span v-else-if="!auditLogLoading" style="color: #909399">暂无审核记录</span>
          </div>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="demo-drawer__footer">
      <el-button
        v-if="detail.auditStatus == 'PENDING_REVIEW' || detail.auditStatus == 'REFUSE'"
        type="primary"
        @click="accept"
      >
        通过
      </el-button>
      <el-button
        v-if="detail.auditStatus == 'PENDING_REVIEW' || detail.auditStatus == 'ACCEPT'"
        type="danger"
        @click="dialogFormVisible1 = true"
      >
        不通过
      </el-button>
    </div>

    <el-drawer ref="drawerRef" v-model="dialogFormVisible1" :append-to-body="true" :size="size1" title="填写驳回原因">
      <el-form ref="reasonRef" :model="form" :rules="rules">
        <el-form-item label="原因" prop="reason">
          <el-input v-model="form.reason" type="textarea" />
        </el-form-item>
        <el-form-item align="center">
          <el-button size="large" type="primary" @click="refuse">提交</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </el-drawer>
</template>
<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, ref, toRefs } from 'vue'
  import { attendAuditDetail, attendAudit, attendAuditLog } from '@/api/exhibitionManage'
  import { parseTime } from '@/utils/index'
  export default defineComponent({
    name: 'UserDetail',
    props: {
      meetingCode: {
        type: String,
        default: '',
      },
    },
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance()
      const state = reactive({
        dialogFormVisible: false,
        dialogFormVisible1: false,
        direction: 'rtl',
        size: '50%',
        size1: '30%',
        detailLoading: false,
        auditLog: [],
        auditLogLoading: false,
        detail: {
          attentFormDtoList: [],
        },
        rules: {
          reason: [
            {
              required: true,
              message: '请填写驳回原因',
              trigger: 'blur',
            },
          ],
        },
        statusList: {
          PENDING_REVIEW: '待审核',
          ACCEPT: `审核通过`,
          REFUSE: '审核不通过',
          CANCEL_SIGN: `取消报名`,
          NOT_REVIEW: `无需审核`,
        },
        form: {
          reason: '',
        },
        identityCard: {
          CERTIFICATES_TYPE_1: '身份证',
          CERTIFICATES_TYPE_2: '回乡证',
          CERTIFICATES_TYPE_3: '台胞证',
          CERTIFICATES_TYPE_4: '永居证',
          CERTIFICATES_TYPE_5: '外国护照',
          CERTIFICATES_TYPE_6: '军人证',
          CERTIFICATES_TYPE_7: '外国人手机验证码认证',
          CERTIFICATES_TYPE_8: '港澳台居民居住证',
          CERTIFICATES_TYPE_99: '其他',
        },
        reasonRef: null,
      })
      // 打开
      const handleOpen = async (row) => {
        state.row = row
        state.dialogFormVisible = true
        state.detailLoading = true
        state.auditLogLoading = true
        state.auditLog = []
        const [detailRes, logRes] = await Promise.allSettled([
          attendAuditDetail(props.meetingCode, row.audienceUid, row.identity),
          attendAuditLog(props.meetingCode, row.audienceUid, row.identity),
        ])
        state.detailLoading = false
        state.auditLogLoading = false
        if (detailRes.status === 'fulfilled') {
          const data = detailRes.value.data
          data.attentFormDtoList.forEach((v) => {
            if (v.type == 'FILEUPLOAD' || v.type == 'AREA') {
              v.formContent = JSON.parse(v.formContent)
            }
          })
          state.detail = data
        } else {
          proxy.$baseMessage(`加载详情失败`, 'error', 'vab-hey-message-error')
          handleClose()
          return
        }
        if (logRes.status === 'fulfilled') {
          state.auditLog = logRes.value.data || []
        }
      }
      // 关闭
      const handleClose = () => {
        state.dialogFormVisible = false
        state.dialogFormVisible1 = false
      }

      const refuse = async () => {
        state['reasonRef'].validate(async (valid) => {
          if (valid) {
            try {
              let parmas = {
                audienceUid: state.row.audienceUid,
                auditStatus: 'REFUSE',
                entranceCode: '',
                identity: state.row.identity,
                meetingCode: props.meetingCode,
                meetingType: props.meetingCode.startsWith('MT') ? 'HOLD_MEETING' : 'EXHIBITION',
                reason: state.form.reason,
              }
              const { data } = await attendAudit(parmas)
              proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
            } catch (err) {
              console.log(err)
              proxy.$baseMessage(`操作失败`, 'error', 'vab-hey-message-error')
            }
            emit('fetch-data')
            state.form.reason = ''
            state['reasonRef']?.clearValidate?.()
            handleClose()
          }
        })
      }
      const accept = async () => {
        try {
          let parmas = {
            audienceUid: state.row.audienceUid,
            auditStatus: 'ACCEPT',
            entranceCode: '',
            identity: state.row.identity,
            meetingCode: props.meetingCode,
            meetingType: props.meetingCode.startsWith('MT') ? 'HOLD_MEETING' : 'EXHIBITION',
            reason: state.form.reason,
          }
          const { data } = await attendAudit(parmas)
          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
        } catch (err) {
          proxy.$baseMessage(`操作失败`, 'error', 'vab-hey-message-error')
        }
        emit('fetch-data')
        handleClose()
      }

      const handleDate = (val) => {
        return parseTime(val)
      }

      function getAuditLogColor(status) {
        return (
          '' +
          (status === 'PENDING_REVIEW'
            ? '#FFA500'
            : status === 'ACCEPT'
            ? '#4CAF50'
            : status === 'REFUSE'
            ? '#F44336'
            : status === 'CANCEL_SIGN'
            ? '#9E9E9E'
            : '#000000')
        )
      }

      return {
        ...toRefs(state),
        handleOpen,
        handleClose,
        refuse,
        accept,
        handleDate,
        getAuditLogColor,
      }
    },
  })
</script>

<style lang="scss">
  .userInfoDrawer {
    .el-transfer-panel {
      width: 250px;
    }

    .hideLabel {
      .el-descriptions__label {
        display: none;
      }
    }
  }
</style>

<style lang="scss" scoped>
  .vab-tree-border {
    height: 200px;
    padding: $base-padding;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: $base-border-radius;
  }

  .demo-drawer__content {
    height: 85vh;
    overflow: auto;
  }

  .containerForm {
    height: 85vh;
    overflow-y: auto;
  }

  .demo-drawer__footer {
    position: fixed;
    right: 20px;
    bottom: 10px;
  }

  .margin-top {
    margin-top: 20px;
  }
</style>
